const EnvironmentComponent = {
    templateUrl: '/userProfileButton/environment/environment.tpl.html',
    controller: 'environmentController',
    bindings: {}
};

angular.module('gw-um-header')
    .component('uiEnvironment', EnvironmentComponent);
